/*
 *
 * DimensionCabinetSelector
 *
 */

import React from 'react';
import Img from 'components/Img';
import Input from '@material-ui/core/Input';
import KewloxSlider from 'components/KewloxSlider';
import styled from 'styled-components/macro';

// eslint-disable-next-line no-restricted-imports

interface Props {
  value: number;
  icon: any;
  handleInput: Function;
  min?: number;
  max?: number;
  marks?: any;
  custom?: boolean;
  label?: string;
  className?: string;
}

function DimensionCabinetSelector({
  icon,
  value,
  handleInput,
  custom,
  label,
  className = '',
  ...sliderOptions
}: Props) {
  const handleSliderChange = (event: any, newValue: any, preview: boolean) => {
    // console.log('handleSliderChange', newValue, preview);
    handleInput(newValue, preview);
  };

  const handleInputChange = (event: any, preview: boolean) => {
    handleInput(
      event.target.value === '' ? '' : Number(event.target.value),
      preview,
    );
  };

  const handleBlur = () => {
    if (value < 0) {
      handleInput(0);
    } else if (value > 5000) {
      handleInput(5000);
    }
  };

  return (
    <StyledSliderContainer>
      <div className="flex-shrink-0 flex-grow-0">
        {label ? (
          <div className="mr-2 text-sm">{label}</div>
        ) : (
          <div className="-mt-1 h-12 w-12 lg:h-10 lg:w-10 mr-2 flex justify-end">
            <Img src={icon} alt="size cabinet" />
          </div>
        )}
      </div>
      <div className="flex-grow flex-shrink max-w-2xl min-h-0">
        <KewloxSlider
          value={value}
          onChange={(e, value) => handleSliderChange(e, value, true)}
          onChangeCommitted={(e, value) => handleSliderChange(e, value, false)}
          aria-labelledby="input-slider"
          valueLabelDisplay="auto"
          valueLabelFormat={(e: number, index: number) => {
            return `${e / 10}`;
          }}
          step={null}
          marks
          {...sliderOptions}
        />
      </div>
      <div className="mx-2 -mt-2 text-lg flex-shrink-0 flex-grow-0">
        {!custom ? (
          value / 10
        ) : (
          <Input
            className="w-10"
            value={value}
            margin="dense"
            onChange={e => handleInputChange(e, false)}
            onBlur={handleBlur}
            inputProps={{
              step: 1,
              min: 0,
              max: 5000,
              type: 'number',
              'aria-labelledby': 'input-slider',
            }}
          />
        )}
        {!custom && ' '}
        <span className="text-xs">{!custom ? 'cm' : 'mm'}</span>
      </div>
    </StyledSliderContainer>
  );
}

export default DimensionCabinetSelector;

const StyledSliderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  margin-left: 0.5rem;
  margin-right: 0.5rem;
  color: ${p => p.theme.gray800};

  @media (hover: none) and (pointer: coarse) {
    margin-top: -0.6rem;
  }

  @media (min-width: 1024px) {
    width: 18rem;
    margin-left: 0;
    margin-right: 0;
  }

  @media (min-width: 1280px) {
    width: 24rem;
  }
`;
